import { Entity, makeClone } from 'gossamer-unified';
import { User } from './User';
import { Person } from './Person';

export interface UserSimpleViewRow {
  id: string;
  first_name: string;
  last_name: string;
  photo: string | null;
}

const clone = makeClone();

export const UserSimpleView: Entity<UserSimpleViewRow> = {
  id: 'UserSimpleView',
  title: 'User',
  service: 'main',
  rowLabel: (row: UserSimpleViewRow) => [row.first_name, row.last_name].join(' '),
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.user_simple_view',
  },
  security: [
    {
      role: 'all',
      action: 'read',
      access: 'all',
    },
  ],
  defaultSort: [['last_name', 'ASC']],
  defaultFilters: [{ fieldId: 'last_name', operator: 'ct', value: '' }],
  fields: {
    id: clone(User.fields.id, { seq: 5, listColumn: false }),
    first_name: clone(Person.fields.first_name, { seq: 10, listColumn: true }),
    last_name: clone(Person.fields.last_name, { seq: 15, listColumn: true }),
    photo: clone(Person.fields.photo, { seq: 20, listColumn: false }),
  },
};
